import { render, staticRenderFns } from "./CustomerActionsMobile.vue?vue&type=template&id=a4b23a3a&"
import script from "./CustomerActionsMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerActionsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports